module.exports = __webpack_public_path__ + "static/7invgde-d08fc6e518a287d62bcaacc981dfe2a7.gif";